import { faChevronDown, faChevronUp, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react'
import ProjectPerk from './ProjectPerk';
import { useSelector } from 'react-redux';
import { selectWhiteListStatus } from '../../../redux/personaliseLessons/whiteListSlice';

const PracticalProjects = () => {

    const whiteListUserStatus = useSelector(selectWhiteListStatus)

    const notInWhiteListUser = whiteListUserStatus?.message === 'Email is not pre registered.'

    const [showProject, setShowProject] = useState(false)

    return (
        <div className='mt-3 bg-[#2D4F71] p-3 rounded-xl'>
            <div className={`flex items-center justify-between ${notInWhiteListUser ? 'cursor-pointer' : ''}`} onClick={() => setShowProject(!showProject)}>
                <div className='flex'>
                    <FontAwesomeIcon icon={faCircleCheck} className='text-[#55A47E] bg-white rounded-full text-xl mr-2'/>
                    <p className='font-medium'>{notInWhiteListUser ? 'Practical Projects & Assessments' : 'Practical Assessments'}</p>
                </div>
                {notInWhiteListUser && (!showProject ?  <FontAwesomeIcon icon={faChevronDown} className='text-xl font-extrabold ml-2' onClick={() => setShowProject(!showProject)}/> : <FontAwesomeIcon icon={faChevronUp} className='text-xl font-extrabold ml-2 mt-1.5'/>)}
            </div>
            {notInWhiteListUser && showProject && <ProjectPerk/>}
        </div>
    )
}

export default PracticalProjects
